import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

import backArrow from '../../assets/images/backarrow.svg';
import googleIcon from '../../assets/images/Google.svg';
import { ReactComponent as LinkedIcon } from '../../assets/images/linked-icon.svg';
import outlookIcon from '../../assets/images/outlook.svg';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import {
  useGetCurrentUserQuery,
  useUnsubscribeGoogleMutation,
  useUnsubscribeOutlookMutation,
} from '../../redux/apis/userApi';
import baseServerUrl from '../../services/apiServer';
import ButtonWithIcon from '../shared/ButtonWithIcon/ButtonWithIcon';

import { RemoveConfirmationModal } from './RemoveConfirmationModal';

import styles from './ConnectNetwork.module.scss';

export const ConnectNetwork = ({ onClose }) => {
  const { t } = useTranslation('common');
  const [showRemoveConfirmationModal, setShowRemoveConfirmationModal] = useState('');
  const { companyName } = useParams();
  const [searchParams] = useSearchParams();
  const referFor = searchParams.get('refer_for');
  const { isAuthenticated } = useCurrentUser();
  const { data: currentUser } = useGetCurrentUserQuery(undefined, { skip: !isAuthenticated });
  const isGoogleConnected = currentUser?.payload?.user?.google_sync_authenticated;
  const isOutlookConnected = currentUser?.payload?.user?.outlook_sync_authenticated;
  const [unsubscribeGoogle, { isLoading: isUnsubscribingGoogle }] = useUnsubscribeGoogleMutation();
  const [unsubscribeOutlook, { isLoading: isUnsubscribingOutlook }] = useUnsubscribeOutlookMutation();

  const handleGoogleConnectPress = () => {
    if (isGoogleConnected) {
      setShowRemoveConfirmationModal('google');
      // unsubscribeGoogle();
    } else {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = `${baseServerUrl}/auth/google_oauth2?new_user_app=true&referral_flow=true${
        companyName ? `&company_id=${companyName}` : ''
      }${referFor ? `&refer_for=${referFor}` : ''}&page=permission&provider=`;
      document.body.appendChild(form);
      form.submit();
    }
  };
  const handleOutlookConnectPress = () => {
    if (isOutlookConnected) {
      setShowRemoveConfirmationModal('outlook');
      // unsubscribeOutlook();
    } else {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = `${baseServerUrl}/auth/microsoft_graph_auth?activate=1&new_user_app=true&referral_flow=true${
        companyName ? `&company_id=${companyName}` : ''
      }${referFor ? `&refer_for=${referFor}` : ''}&page=permission&provider=`;
      document.body.appendChild(form);
      form.submit();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.title}>{t('network.sendReferral')}</p>
      </div>
      <div className={styles.content}>
        <p className={styles.contentText}>{t('network.connectNetworkDescription')}</p>
        <div className={styles.contentButtons}>
          <ButtonWithIcon
            img={googleIcon}
            type="button"
            variant="tertiary-36"
            text={
              <span className="flex items-center gap-[8px]">
                {t('network.google')} {isGoogleConnected && <LinkedIcon />}
              </span>
            }
            imgClassName="w-[24px] h-[24px]"
            containerClass="max-md:w-full"
            onClick={handleGoogleConnectPress}
          />
          <ButtonWithIcon
            img={outlookIcon}
            type="button"
            variant="tertiary-36"
            text={
              <span className="flex items-center gap-[8px]">
                {t('network.outlook')} {isOutlookConnected && <LinkedIcon />}
              </span>
            }
            containerClass="max-md:w-full"
            onClick={handleOutlookConnectPress}
          />
        </div>
      </div>
      <div className={styles.footer}>
        <ButtonWithIcon
          img={backArrow}
          type="button"
          variant="tertiary-36"
          text={t('back')}
          textClassName="text-[#314155]"
          containerClass="w-[142px]"
          onClick={onClose}
        />
      </div>
      <RemoveConfirmationModal
        show={showRemoveConfirmationModal}
        onClose={() => setShowRemoveConfirmationModal('')}
        type={showRemoveConfirmationModal}
        onRemove={() => {
          if (showRemoveConfirmationModal === 'google') {
            unsubscribeGoogle()
              .unwrap()
              .then(() => setShowRemoveConfirmationModal(''));
          } else {
            unsubscribeOutlook()
              .unwrap()
              .then(() => setShowRemoveConfirmationModal(''));
          }
        }}
        isLoading={isUnsubscribingGoogle || isUnsubscribingOutlook}
      />
    </div>
  );
};
